const instructionsBasePath = "/instructions";

const InstructionConst = {
  basePath: instructionsBasePath,
};

export default InstructionConst;
